import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Promise from 'bluebird';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import FormField from 'shared/components/ui/formField';
import { updateUser } from '../login/actions';
import {
  validEmail,
  validMobile,
  formatBirthday,
  displayBirthday
} from 'shared/models/user';

let AccountDetails = class AccountDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errors: {},
      loading: false,
      success: false,
      firstname: props.user.firstname,
      lastname: props.user.lastname,
      email: props.user.email,
      mobile: props.user.mobile,
      birthday: props.user.birthday
    };
  }

  validateFirstname(name) {
    if (_.isEmpty(name)) return "First Name can't be blank";
  }

  validateLastname(name) {
    if (_.isEmpty(name)) return "Last Name can't be blank";
  }

  validateEmail(email) {
    if (!validEmail(email)) return 'Email is not valid';
  }

  validateMobile(number) {
    if (!validMobile(number)) return 'Mobile number is not valid';
  }

  validateFields() {
    const { firstname, lastname, email, mobile } = this.state;

    let errors = {};
    errors.firstname = this.validateFirstname(firstname) || null;
    errors.lastname = this.validateLastname(lastname) || null;
    errors.email = this.validateEmail(email) || null;
    errors.mobile = this.validateMobile(mobile) || null;

    this.setState({ errors });

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  _submit() {
    const data = {
      firstname: this.state.firstname.trim(),
      lastname: this.state.lastname.trim(),
      email: this.state.email.trim(),
      mobile: this.state.mobile.trim(),
      birthday: formatBirthday(this.state.birthday)
    };

    return this.props.updateUser(data);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, success: false, error: null });
    this.validateFields()
      .then(() => this._submit())
      .then(() => this.setState({ loading: false, success: true }))
      .catch(({ message }) => {
        this.setState({ loading: false, error: message });
      });
  }

  render() {
    const user = this.props.user;
    if (!user) return null;

    return (
      <form onSubmit={e => this.handleSubmit(e)}>
        {this.state.loading && <LoadingSpinner green />}

        <div className="row">
          <div className="col-xs-12 col-sm-6 input-row">
            <FormField
              id="user-first-name"
              name="fname"
              labelText="First Name"
              initialValue={user.firstname}
              updatedValue={this.state.firstname}
              onChange={firstname => this.setState({ firstname })}
              validate={firstname => this.validateFirstname(firstname)}
              error={this.state.errors.firstname}
            />
          </div>
          <div className="col-xs-12 col-sm-6 input-row">
            <FormField
              id="user-last-name"
              name="lname"
              labelText="Last Name"
              initialValue={user.lastname}
              updatedValue={this.state.lastname}
              onChange={lastname => this.setState({ lastname })}
              validate={lastname => this.validateLastname(lastname)}
              error={this.state.errors.lastname}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6 input-row">
            <FormField
              id="user-email"
              name="email"
              labelText="Email"
              inputType="email"
              initialValue={user.email}
              updatedValue={this.state.email}
              onChange={email => this.setState({ email })}
              validate={email => this.validateEmail(email)}
              error={this.state.errors.email}
            />
          </div>

          <div className="col-xs-12 col-sm-6 input-row">
            <FormField
              id="user-mobile"
              name="phone"
              labelText="Mobile No."
              inputType="tel"
              initialValue={user.mobile}
              updatedValue={this.state.mobile}
              onChange={mobile => this.setState({ mobile })}
              validate={mobile => this.validateMobile(mobile)}
              error={this.state.errors.mobile}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6 input-row">
            <FormField
              id="user-birthday"
              name="birthday"
              labelText="Birthday"
              placeholder="mm/dd/yyyy"
              disabled
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              inputType="tel"
              initialValue={displayBirthday(user.birthday)}
            />
          </div>
        </div>

        {this.state.error && (
          <div className="row">
            <div className="col-xs-12">
              <span className="error">{this.state.error}</span>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <button
              type="submit"
              disabled={this.state.loading}
              className="btn-primary btn-block"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    );
  }
};

const mapStateToProps = state => {
  return {
    user: state.login.user
  };
};

export default connect(mapStateToProps, { updateUser })(AccountDetails);



// WEBPACK FOOTER //
// ./shared/components/account/accountDetails.js